import React, {useState} from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

const EventsAndMetricsExpanded = (props) => {
  const [openDialog, setOpenDialog] = useState(false);

  const rowDataList = [
    {label: 'Date and Time', value: props.timestamp},
    {label: 'Type', value: props.message_type},
    {label: 'Subject', value: props.subject, bolder: true},
    {label: 'Component', value: props.component},
    {label: 'Component ID', value: props.component_id},
    {label: 'Subcomponent', value: props.sub_component},
    {label: 'Subcomponent ID', value: props.sub_component_id},
    {label: 'Values', value: 'Click to view', clickable: true},
  ];

  const dialogDataList = () => {
    const list = [];
    const {attributes} = props;
    if(attributes !== undefined && attributes !== null) {
      for (let key in attributes) {
        let listItem = {label: key, value: attributes[key]};
        list.push(listItem);
      }
    }
    return list;
  }

  function row(list) {
    return (
      <>
        <div className='infrastructure-expanded'>
          <div className='border'>
            <List className="list-horizontal-flex">
              {list.map(item => item.clickable ? clickableStaticText(item) : staticText(item))}
            </List>
          </div>
        </div>
      </>
    );
  }

  function dialog() {
    return (
      <Dialog open={openDialog} className={'dialog-width'}>
        <DialogContent>
          {row(dialogDataList())}
        </DialogContent>
        <DialogActions style={{paddingLeft: '24px', paddingRight: '24px'}}>
          <Button onClick={() => setOpenDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    );
  }

  function staticText(item) {
    return (
      <div>
        {createListItem(item)}
        <Divider />
      </div>
    );
  }

  function clickableStaticText(item) {
    return (
      <div style={{cursor: 'pointer'}} onClick={() => setOpenDialog(true)}>
        {createListItem(item)}
        <Divider />
      </div>
    );
  }

  function createListItem(item) {
    const {label, value, bolder} = item;
    let listItemClassName = bolder ? 'listItem-fontWeight' : null;
    return (
      <ListItem classes={{ root: 'attributes', disabled: 'opaque' }} disabled={false}>
        <ListItemText primary={label} secondary={value || '-'} className={listItemClassName} />
      </ListItem>
    );
  }

  return (
    <>
      {row(rowDataList)}
      {dialog()}
    </>
  );
}

export default React.memo(EventsAndMetricsExpanded);
